// store.js

import { createStore } from 'redux';
import authReducer from './AuthReducer';

// Load state from local storage (if available)
const persistedState = localStorage.getItem('reduxState')
  ? JSON.parse(localStorage.getItem('reduxState'))
  : {};

const store = createStore(authReducer, persistedState);

// Save state to local storage whenever it changes
store.subscribe(() => {
  
  localStorage.setItem('reduxState', JSON.stringify(store.getState()));
});

export default store;
